import dataProvider from '../supabase/dataProvider'

async function createNotification (payload) {
  if ( ! payload.profile_id ) return

  try {
    await dataProvider.create('profiles_notifications', {
      data: payload
    })
  } catch (error) {
    console.error('Error creating notification:', error.message)
    return
  }

  console.log('Notification created : ', payload.title)
}

export default createNotification